/* @flow */

import SweetAlerts from 'sweetalert2';
import { BRAND_COLOR } from './constants';

const swal = SweetAlerts.mixin({
    confirmButtonColor: BRAND_COLOR,
    cancelButtonText: 'Cancelar',
    reverseButtons: true,
});

export const toast = swal.mixin({
    toast: true,
    timer: 4000,
    showConfirmButton: false,
    position: 'bottom',
});

export const toastSuccess = toast.mixin({
    type: 'success',
});

export const toastError = toast.mixin({
    type: 'error',
});

export default swal;
